// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__2CX4R","box":"WorkspacesBox_box__iPeA9","node":"WorkspacesBox_node__3CRT2"};